module.exports = __webpack_public_path__ + "static/media/envEduButton.0fc9e8a8.png";